var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilterSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.488,
    viewBox: "0 0 20 20.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#495057",
    d: "M19.138 0H.861A.859.859 0 0 0 .1.466a.87.87 0 0 0 .068.906l6.7 9.427.007.01a1.91 1.91 0 0 1 .376 1.134v7.686a.855.855 0 0 0 .855.86.882.882 0 0 0 .337-.068l3.757-1.435a.815.815 0 0 0 .561-.8v-6.244a1.911 1.911 0 0 1 .375-1.134l.007-.01 6.7-9.427A.869.869 0 0 0 19.9.466.858.858 0 0 0 19.138 0zm0 0",
    transform: "translate(.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterSilver);
export default __webpack_public_path__ + "static/media/icon-filter-silver.dc8910e1a9fc170558f77c7f03e1be68.svg";
export { ForwardRef as ReactComponent };